import { ApplicationController } from "../support/application-controller";

export default class extends ApplicationController {
    static targets = ["statusBadge", "statusMessage", "startedAt", "finishedAt", "syncButton"];

    connect() {
        if (this._currentStatus() === "running") {
            this._startPolling();
        }
    }

    disconnect() {
        this._stopPolling();
    }

    _currentStatus() {
        return this.statusBadgeTarget.dataset.status;
    }

    _startPolling() {
        this._disableSyncButton();
        this.pollingInterval = setInterval(() => this._poll(), 3000);
    }

    _stopPolling() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
    }

    _poll() {
        fetch("/admin/database-sync/status", {
            headers: { "Accept": "application/json" }
        })
            .then(response => response.json())
            .then(data => {
                this._updateStatus(data);
                if (data.status !== "running") {
                    this._stopPolling();
                    this._enableSyncButton();
                }
            })
            .catch(error => {
                console.error("Failed to poll sync status:", error);
            });
    }

    _updateStatus(data) {
        this.statusBadgeTarget.dataset.status = data.status;
        this.statusBadgeTarget.textContent = this._statusLabel(data.status);
        this.statusBadgeTarget.className = "database-sync__status-badge database-sync__status-badge--" + data.status;

        if (this.hasStatusMessageTarget && data.message) {
            this.statusMessageTarget.textContent = data.message;
        }

        if (this.hasStartedAtTarget && data.started_at) {
            this.startedAtTarget.textContent = new Date(data.started_at).toLocaleString();
        }

        if (this.hasFinishedAtTarget && data.finished_at) {
            this.finishedAtTarget.textContent = new Date(data.finished_at).toLocaleString();
            this.finishedAtTarget.closest("tr").style.display = "";
        }
    }

    _statusLabel(status) {
        const labels = { idle: "Idle", running: "Running", completed: "Completed", failed: "Failed" };
        return labels[status] || status;
    }

    _disableSyncButton() {
        if (this.hasSyncButtonTarget) {
            this.syncButtonTarget.disabled = true;
            this.syncButtonTarget.textContent = "Sync in progress...";
        }
    }

    _enableSyncButton() {
        if (this.hasSyncButtonTarget) {
            this.syncButtonTarget.disabled = false;
            this.syncButtonTarget.textContent = "Pull Development Database";
        }
    }
}
